var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0515 6.1725C11.6522 6.1725 12.1392 6.65945 12.1392 7.26013V15.9611C12.1392 16.5618 11.6522 17.0488 11.0515 17.0488C10.4509 17.0488 9.96392 16.5618 9.96392 15.9611V7.26013C9.96392 6.65945 10.4509 6.1725 11.0515 6.1725Z",
    fill: "#0050AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61342 11.6106C5.61342 11.0099 6.10037 10.523 6.70105 10.523H15.402C16.0027 10.523 16.4897 11.0099 16.4897 11.6106C16.4897 12.2113 16.0027 12.6983 15.402 12.6983H6.70105C6.10037 12.6983 5.61342 12.2113 5.61342 11.6106Z",
    fill: "#0050AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0515 2.90963C6.24612 2.90963 2.35054 6.8052 2.35054 11.6106C2.35054 16.4161 6.24612 20.3116 11.0515 20.3116C15.857 20.3116 19.7525 16.4161 19.7525 11.6106C19.7525 6.8052 15.857 2.90963 11.0515 2.90963ZM0.175293 11.6106C0.175293 5.60384 5.04476 0.734375 11.0515 0.734375C17.0583 0.734375 21.9278 5.60384 21.9278 11.6106C21.9278 17.6174 17.0583 22.4869 11.0515 22.4869C5.04476 22.4869 0.175293 17.6174 0.175293 11.6106Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcoCircle);
export default __webpack_public_path__ + "static/media/plus_ico_circle.599221bbfc42990205061a1f1bb5c3ea.svg";
export { ForwardRef as ReactComponent };